// Rebuy Smart cart translations
(function() {
  const translations = {
    denmark: {
      rebuy_cart_title: "Din kurv",
      rebuy_subtotal: "Subtotal",
      your_cart_is_empty: "Din kurv er tom!",
      add_your_favorite_items: "Tilføj dine yndlingsprodukter til kurven.",
      empty_cart_shop_button: "Shop nu",
      shopping_cart: "Shopping Cart",
      go_to_checkout: "Checkout",
    },
    international: {
      rebuy_cart_title: "Cart",
      rebuy_subtotal: "Subtotal",
      your_cart_is_empty: "Your cart is empty!",
      add_your_favorite_items: "Add your favorite items to your cart.",
      empty_cart_shop_button: "Shop now",
      shopping_cart: "Shopping Cart",
      go_to_checkout: "Checkout",
    },
    spain: {
      rebuy_cart_title: "Envío",
      rebuy_subtotal: "Subtotal",
      your_cart_is_empty: "¡Tu carrito está vacío!",
      add_your_favorite_items: "Agrega tus artículos favoritos al carrito.",
      empty_cart_shop_button: "Comprar ahora",
      shopping_cart: "Carrito de compras",
      go_to_checkout: "Finalizar compra",
    },
  }

  function getCurrentLocale() {
    const locale = (window.PXUTheme?.theme_settings?.current_locale || '').toLowerCase();
    
    switch(locale) {
      case 'es':
        return 'spain';
      case 'dk':
        return 'denmark';
      default:
        return 'international';
    }
  }

  function translateSmartCart () {
    const currentLocale = getCurrentLocale();
    const cartTitle = document.querySelector('#rebuy-cart-title');
    if (cartTitle) {
      cartTitle.textContent = translations[currentLocale]?.rebuy_cart_title || translations.en.rebuy_cart_title;
    }

    const subtotalElement = document.querySelector('.rebuy_subtotal_text');
    if (subtotalElement) {
      subtotalElement.textContent = translations[currentLocale]?.rebuy_subtotal || translations.en.rebuy_subtotal;
    }

    const emptyCartElement = document.querySelector('.rebuy-cart__flyout-empty-cart h4');
    const emptyCartSubtextElement = document.querySelector('.rebuy-cart__flyout-empty-cart p');
    const emptyCartButtonElement = document.querySelector('.rebuy-cart__flyout-empty-cart a');
    if (emptyCartElement && emptyCartSubtextElement) {
      emptyCartElement.textContent = translations[currentLocale]?.your_cart_is_empty || translations.en.your_cart_is_empty;
      emptyCartSubtextElement.textContent = translations[currentLocale]?.add_your_favorite_items || translations.en.add_your_favorite_items;
      emptyCartButtonElement.textContent = translations[currentLocale]?.empty_cart_shop_button || translations.en.empty_cart_shop_button;
    }
  }


  document.addEventListener("rebuy:smartcart.ready", (event) => {
    translateSmartCart();
  });
  document.addEventListener("rebuy:cart.change", (event) => {
    translateSmartCart();
  });
})();